var styleDataHash = "2ddc5e64";
const injectCss = () => {
  var css = `.anJHN{--wds-button-size-small:36px;--wds-color-picker-padding-vertical:12px 0px;--wds-color-picker-padding-horizontal:6px 0px;--wds-color-picker-width:100%}.PTuiQ{--wds-side-panel-footer-padding-horizontal:18px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var custom_color_picker_default = {
  "customPicker": "anJHN",
  "header": "PTuiQ"
};
export {
  custom_color_picker_default as default,
  injectCss
};
//# sourceMappingURL=custom-color-picker-scss.js.map
